import { useQuery } from '@tanstack/react-query';
import { FieldValues } from 'react-hook-form';

import { translationMembershipOptions } from '@/module/Nomen/TranslationMembership/model/TranslationMembershipModel';

import { AsyncSelectControl, AsyncSelectControlProps } from '@/core/components';

type TranslationMembershipSelectControlProps<T extends FieldValues> = Omit<
  AsyncSelectControlProps<T>,
  'isError' | 'isLoading' | 'options'
>;

export function TranslationMembershipSelectControl<T extends FieldValues>(
  props: TranslationMembershipSelectControlProps<T>,
) {
  const { data, isLoading, isError } = useQuery(translationMembershipOptions.getAll());

  return (
    <AsyncSelectControl
      isError={isError}
      isLoading={isLoading}
      options={data ?? []}
      {...props}
    />
  );
}
